import React, { useEffect, useState, } from 'react';
import { CalendarStateToken, ColorTokens, FontSizeTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, TextInputTypeToken, } from '@voltmoney/schema';
import Stack from '../stack/Stack';
import TextInput from '../textInput/TextInput';
import { Space } from '../space/Space';
import { Typography } from '../typography/Typography';
import { View } from 'react-native';
const CalendarPicker = ({ id, year, month, date, spacing = { size: SizeTypeTokens.XL }, action, triggerAction, caption, state = CalendarStateToken.DEFAULT, minYear = 0, maxYear = 0, metaData, ...props }) => {
    const [isFocus, setFocus] = useState(state === CalendarStateToken.FOCUS);
    const [isRefReady, setRefReady] = useState(false);
    const TextInputRefMap = { 0: null, 1: null, 2: null };
    useEffect(() => {
        if (isFocus && isRefReady) {
            TextInputRefMap[1].blur();
            TextInputRefMap[2].blur();
        }
    }, [isRefReady]);
    const renderCaption = () => !caption ? (React.createElement(React.Fragment, null)) : (React.createElement(React.Fragment, null,
        React.createElement(Stack, { type: StackType.column },
            React.createElement(Space, { size: SizeTypeTokens.MD }),
            React.createElement(Stack, { type: StackType.row },
                state === CalendarStateToken.DEFAULT &&
                    caption.default && (React.createElement(Typography, { label: caption.default, fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Smoke, fontWeight: '400' })),
                state === CalendarStateToken.SUCCESS &&
                    caption.success && (React.createElement(Typography, { label: caption.success, fontSize: FontSizeTokens.XS, color: ColorTokens.System_Happy, fontWeight: '400' })),
                state === CalendarStateToken.ERROR &&
                    caption.error && (React.createElement(Typography, { label: caption.error, fontSize: FontSizeTokens.XS, color: ColorTokens.System_Error, fontWeight: '400' }))))));
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { type: StackType.row, alignItems: StackAlignItems.center, justifyContent: StackJustifyContent.center, width: StackWidth.CONTENT },
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    width: '100%',
                } }, [date, month, year].map((item, index) => (React.createElement(View, { style: {
                    flex: 1,
                    marginRight: !(index === 2) ? 16 : 0,
                } },
                React.createElement(TextInput, { id: item.id, onlyNumeric: true, metaData: {
                        ...metaData,
                        widgetId: metaData?.widgetId + index,
                    }, isFocus: false, value: item.value, keyboardType: KeyboardTypeToken.numeric, type: InputTypeToken.DEFAULT, onChangeText: (text) => {
                        if (index === 0 &&
                            `${text}`.length > 1 &&
                            date.value.length < 2) {
                            TextInputRefMap[1].focus();
                        }
                        else if (index === 1 &&
                            `${text}`.length > 1 &&
                            month.value.length < 2) {
                            TextInputRefMap[2].focus();
                        }
                        if (index === 0) {
                            date.value = text;
                        }
                        else if (index === 1) {
                            month.value = text;
                        }
                        else {
                            year.value = text;
                        }
                        if (action && triggerAction) {
                            triggerAction({
                                ...action,
                                payload: {
                                    ...action.payload,
                                    value: `${date.value}-${month.value}-${year.value}`,
                                },
                            });
                        }
                    }, title: item.title, placeholder: item.placeholder, width: TextInputTypeToken.FULL, state: InputStateToken[state === CalendarStateToken.ERROR
                        ? InputStateToken.ERROR
                        : InputStateToken.DEFAULT], charLimit: index === 2 ? 4 : 2, charLimitVisibility: false, isSuccessIcon: false, getRef: (ref) => {
                        TextInputRefMap[index] = ref;
                        if (index === 2) {
                            setRefReady(true);
                        }
                    }, delayedRequestFocus: false })))))),
        renderCaption()));
};
export default React.memo(CalendarPicker);
export { CalendarPicker };
